import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { usePagedListing, useSafeSistaAsync, } from "@sista/library-stasi";
import { useCallback, useEffect, useMemo, useState } from "react";
import { DistaAutocomplete } from "@sista/dista-ui";
import { Typography } from "@mui/material";
import { useSpravaTextuClient } from "../../util/useSpravaTextuClient";
const pageSize = 100;
export const SelectNamespace = ({ onNamespacesSelected, multiple, size, sxProps, isChanged, onRefresh, helperText, }) => {
    const { t } = useTranslation("sprava-textu");
    const spratex = useSpravaTextuClient();
    const [selectNamespaces, setSelectedNamespace] = useState(undefined);
    const [getAllNamespacesCall, getAllNameSpacesState] = useSafeSistaAsync(spratex.findNamespaces);
    const loader = useCallback(async (page) => {
        const result = await getAllNamespacesCall({
            page: page,
            pageSize: pageSize,
        });
        if (result == null) {
            return [];
        }
        return result;
    }, [getAllNamespacesCall]);
    const { currentPage, error, pending, refresh, rows } = usePagedListing({
        loader,
        maxRows: 300,
    });
    const options = useMemo(() => {
        return (rows
            // Adminovi se ve výpisu vrací i smazané prostory, se kterými ale nelze pracovat.
            .filter((row) => row.dateDeleted == null)
            .map((row) => ({
            label: row.namespace,
            value: row.namespace + "|" + row.format,
        }))
            .sort((a, b) => a.label.localeCompare(b.label)));
    }, [rows]);
    const findNamespaceDto = useCallback((value) => {
        for (const row of rows) {
            if (row.namespace + "|" + row.format === value) {
                return row;
            }
        }
        return null;
    }, [rows]);
    useEffect(() => {
        if (isChanged) {
            refresh();
            onRefresh();
        }
    }, [isChanged, refresh, onRefresh]);
    return (_jsx(DistaAutocomplete, { label: t("sprava-textu.selectNamespace.label", "Vyberte jmenný prostor"), value: selectNamespaces, options: options, multiple: multiple ?? true, isOptionEqualToValue: (option, value) => option.value === value.value, onChange: (e, newValue) => {
            if (!multiple) {
                setSelectedNamespace(newValue.value);
                return onNamespacesSelected(findNamespaceDto(newValue.value));
            }
            setSelectedNamespace(newValue.map((v) => v.value));
            return onNamespacesSelected(newValue.map((v) => findNamespaceDto(v.value)));
        }, helperText: helperText ? _jsx(Typography, { color: "error", children: helperText }) : null, size: size ?? "medium", sx: { minWidth: "10em", ...sxProps } }));
};
